import { Icon, type IconifyIcon } from "@iconify/react";
import { Box, type BoxProps } from "@mui/material";
import { memo } from "react";

export type IconifyProps = {
  icon: IconifyIcon | string;
  width?: number;
  padding?: string;
} & BoxProps;

const IconComponent = ({
  icon,
  size,
  sx,
  ...props
}: IconifyProps & { size: string }) => (
  <Box
    component={Icon}
    icon={icon}
    sx={{
      width: size,
      height: size,
      ...sx,
    }}
    {...props}
  />
);

const Iconify = ({ icon, padding, width = 20, sx, ...props }: IconifyProps) => {
  const size = padding ? `calc(${width}px - ${padding} * 2)` : `${width}px`;

  return padding ? (
    <Box sx={{ padding, width, height: width }}>
      <IconComponent icon={icon} size={size} sx={sx} {...props} />
    </Box>
  ) : (
    <IconComponent icon={icon} size={size} sx={sx} {...props} />
  );
};

export default memo(Iconify);
